import { render, staticRenderFns } from "./YardControlBodiesTable.vue?vue&type=template&id=4c854812&"
import script from "./YardControlBodiesTable.vue?vue&type=script&lang=js&"
export * from "./YardControlBodiesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports